import React from "react";
import SearchableSelect from "modules/swiftboard/components/ui/SearchableSelect";
import { CAMPAIGN_TYPE_OPTIONS } from "../../features/campaign.constants";

const inputClass = (hasError) =>
  `w-full px-3 py-2 text-sm rounded-lg border bg-surface_alt text-text_primary placeholder:text-text_muted focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition ${
    hasError ? "border-danger" : "border-border"
  }`;

const StepDetails = ({ formData, setField, errors }) => {
  return (
    <div className="grid grid-cols-1 gap-4">
      <div>
        <label className="block text-xs font-medium text-text_secondary mb-1.5">
          Campaign Name <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          value={formData.campaign_name || ""}
          onChange={(e) => setField("campaign_name", e.target.value)}
          placeholder="e.g. Spring Sale Announcement"
          className={inputClass(errors.campaign_name)}
        />
        {errors.campaign_name && <p className="text-[11px] text-danger mt-1">{errors.campaign_name}</p>}
      </div>

      <div>
        <label className="block text-xs font-medium text-text_secondary mb-1.5">Campaign Type</label>
        <SearchableSelect
          options={CAMPAIGN_TYPE_OPTIONS}
          value="MARKETING"
          onChange={() => {}}
          isDisabled
        />
      </div>
    </div>
  );
};

export default StepDetails;
